import { useDispatch } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';

import { AUTH_MODAL_TYPES, openAuthModal } from '@/store/profile';

function ChangePasswordRedirect() {
	const { token } = useParams();
	const dispatch = useDispatch();

	dispatch(openAuthModal({ type: AUTH_MODAL_TYPES.CHANGE_PASSWORD }));

	return <Navigate to="/" replace state={{ resetPasswordToken: token }} />;
}

export default ChangePasswordRedirect;
